import styled from 'styled-components';

export const Container = styled.div``;

export const TitleText = styled.h1`  
  font-size: 24px;
  font-weight: bold;
  line-height: 37px;
  color: #0B29FB;
`;

export const SubTitleText = styled.h2`
  font-size: 16px;  
  line-height: 25px;
  color: #7A7A7A;
`;

export const LegendsWrap = styled.div`
  display: flex;
  margin-top: 25px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

  @media(max-width: 680px) {
    flex-direction: column;
  }
`;

export const LegendContainer = styled.div`
  margin: 5px;
`

export const Acronym = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: #7A7A7A;
`;

export const Description = styled(Acronym)`
    font-weight: 400;
`;
